export enum MealStatus {
  Finish = 'finish',
  Remaining = 'remaining',
  Waiting = 'waiting',
  Deleted = 'deleted',
}

export enum FeedingType {
  Auto = 2,
  Manual = 1,
}

export const MAX_MEAL = 5